// Trigger a browser download of a Blob (or ArrayBuffer/Uint8Array wrapped
// in a Blob). Replacement for Tauri's saveDialog + writeFile flow.
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Delay revoke slightly to let the browser start the download
  setTimeout(() => URL.revokeObjectURL(url), 1_000);
}

// Convenience for docx/txt buffers coming out of the client-side generators.
export function downloadBuffer(
  data: ArrayBuffer | Uint8Array,
  filename: string,
  mime = "application/octet-stream",
): void {
  const view = data instanceof Uint8Array ? data : new Uint8Array(data);
  // Copy into a fresh ArrayBuffer to satisfy Blob's BlobPart typing when
  // the source is a Uint8Array over a SharedArrayBuffer.
  const buffer = new ArrayBuffer(view.byteLength);
  new Uint8Array(buffer).set(view);
  downloadBlob(new Blob([buffer], { type: mime }), filename);
}

// Open an external URL in a new tab. Replacement for @tauri-apps/plugin-opener
// openUrl().
export function openExternal(url: string): void {
  window.open(url, "_blank", "noopener,noreferrer");
}
